import PropTypes from "prop-types"
import styled from "react-emotion"
import WithMarginAndPadding from "../utils/WithMarginAndPadding"

const Section = styled(WithMarginAndPadding)`
    // Basically, a section is a vertical stacking (column-based) flex container

    display: flex;
    flex-direction: column;
    flex-shrink: 1;

    // Custom margin and padding defaults
    margin: ${props => props.theme[props.margin || "medium"]};
    ${props => !props.marginRight && `margin-right: 0px;`}
    ${props => !props.marginLeft && `margin-left: 0px;`}
    padding: ${props => props.theme[props.padding || "medium"]};

    ${props =>
        props.maxSize &&
        `
        flex-grow: ${props.maxSize};
    `}
    ${props =>
        props.spaced &&
        `
        justify-content: space-between;
    `}
    ${props =>
        props.wrapItems &&
        `
        flex-wrap: wrap;
    `}

    
`

Section.propTypes = {
    ...WithMarginAndPadding.propTypes,
    maxSize: PropTypes.number,
    spaced: PropTypes.bool,
    wrapItems: PropTypes.bool,
}
export default Section



// WEBPACK FOOTER //
// ./src/ui/components/Section.js